export default Backbone.Model.extend({
  // The Query model contains all of the state of the search query
  // on the page.  There is only one instance of this model on the page.
  DAYS_OF_WEEK_ATTRS: [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ],
  DATE_ATTRS: ['start_date', 'end_date'],

  isFromAmpSearch() {
    return this.get('amp_search');
  },

  isDateConstrained() {
    const serviceType = this.serviceType();

    if (serviceType && serviceType.supports_day_of_week_search) {
      return _.any(this.DAYS_OF_WEEK_ATTRS, d => this.get(d) === true, this);
    }
    return this.get('start_date') && this.get('end_date');
  },

  serviceType() {
    return _.findWhere(Rover.serviceTypesJson, {
      slug: this.get('service_type'),
    });
  },
  toJSON() {
    const json = Backbone.Model.prototype.toJSON.call(this);

    if (json.minprice != null) {
      json.minprice = json.minprice[json.service_type];
    }

    if (json.maxprice != null) {
      json.maxprice = json.maxprice[json.service_type];
    }

    return json;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/query.js